"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HIGH = 'high';
exports.LOW = 'low';
exports.MEDIUM = 'mid';
exports.SEVERE = 'severe';
exports.NOTE = 'note';
exports.VIDEO = 'video';
exports.GALLERY = 'gallery';
exports.MEMO_PRIORITIES = [exports.LOW, exports.MEDIUM, exports.HIGH, exports.SEVERE, exports.NOTE, exports.VIDEO, exports.GALLERY];
